import { CONSTANT } from '@/constant/index'
import AuoReply from './autoReply'
import * as Utils from '@/assets/script/utils'
import { selectAppletOperate } from '@/database/index'
import ENV from '@/database/env'

class SocketModel {
  constructor(chatControl) {
    this.chatControl = chatControl
    // 客服连接状态
    this.disconnected = true
    // 客服在线时间段
    // this.connectTimeSlot = ['8:00', '21:00']
    // 客服自动回复
    this.auoReply = new AuoReply(chatControl)
  }

  async init() {
    console.log('🔍 [SocketControl] 开始初始化WebSocket连接')
    const { startTime, endTime, message } = await selectAppletOperate()
    console.log('🔍 [SocketControl] 获取到客服时间配置:', { startTime, endTime, message })
    
    // 开始时间和结束时间一样时，不判断在线时间
    if(startTime !== endTime){
      console.log('🔍 [SocketControl] 检查客服在线时间')
      if (!this.isConnectByTime(startTime, endTime)) {
        console.log('❌ [SocketControl] 不在客服工作时间，显示提示信息')
        this.chatControl.addInfoNotTime(message)
        return
      }
    }

    console.log('✅ [SocketControl] 客服时间检查通过，开始建立连接')

    // 显示连接中
    this.chatControl.chatModel.showConnecting(info => {
      this.connectId = info.id
      console.log('🔍 [SocketControl] 显示连接中状态，connectId:', this.connectId)
    })

    const path = ENV.socketUrl + Utils.objToUrlParams(this.chatControl.userInfo)
    console.log('🔍 [SocketControl] WebSocket连接地址:', path)
    console.log('🔍 [SocketControl] 用户信息:', this.chatControl.userInfo)
    
    this.socket = io.connect(path, {
      transports: ['websocket'],
      reconnection: false,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 99999
    })
    
    console.log('🔍 [SocketControl] WebSocket实例创建完成')
    
    this.lineUp()
    this.empty()
    this.customerRead()
    this.customerWithdraw()
    this.customerEntering()

    console.log('🔍 [SocketControl] 开始监听消息接收')
    await this.receive()
    this.signOut()

    this.socket.on('connect_error', error => {
      console.error('❌ [SocketControl] WebSocket连接错误:', error)
      console.error('❌ [SocketControl] 错误详情:', {
        message: error.message,
        description: error.description,
        context: error.context
      })
      this.socket.close()
    })
    
    this.socket.on('connect', () => {
      console.log('✅ [SocketControl] WebSocket连接成功')
    })
    
    this.socket.on('disconnect', (reason) => {
      console.log('⚠️ [SocketControl] WebSocket连接断开，原因:', reason)
    })
    
    this.socket.on('reconnect_attempt', () => {
      console.log('🔄 [SocketControl] 尝试重连，切换到polling模式')
      this.socket.io.opts.transports = ['polling', 'websocket']
    })
  }

  /**
   * 是否再指定时间段
   */
  isConnectByTime(startTime, endTime) {
    const date = new Date(),
      dateStr = Utils.formatDate(date, 'yyyy-MM-dd'),
      startDateTime = `${dateStr} ${startTime}`,
      endDateTime = `${dateStr} ${endTime}`
    // 开始时间和结束时间是反过来的
    return Utils.isDuringDate(endDateTime,startDateTime)
  }

  /**
   * 发送消息
   * @param {string} content 发送信息
   * @param {string} id info id
   */
  async send(content, id) {
    console.log('📤 [SocketControl] 准备发送消息:', { content, id })
    const params = {
      fromUid: this.chatControl.userInfo.token,
      toUid: this.servicer.id,
      msgid: id,
      message: content
    }
    console.log('🔍 [SocketControl] 发送消息参数:', params)
    this.socket.emit('say.customerAdmin.customer', params, res => {
      console.log('📨 [SocketControl] 发送消息回调:', res)
      if (res.code !== 1) {
        console.error('❌ [SocketControl] 发送消息失败:', res.msg)
        this.servicer = null
        this.chatControl.addInfoBySystem(res.msg)
      } else {
        console.log('✅ [SocketControl] 消息发送成功')
      }
      // 客服未回消息自动回复
      // this.auoReply.addInfoByNotReply()
    })
  }

  /**
   * 接收消息
   */
  receive() {
    return new Promise(resolve => {
      console.log('🔍 [SocketControl] 开始监听客服分配消息')
      this.socket.on('say.w', async result => {
        console.log('📨 [SocketControl] 收到消息:', result)
        resolve(result)
        if (!this.servicer) {
          console.log('🎉 [SocketControl] 首次收到消息，分配客服成功')
          console.log('🔍 [SocketControl] 客服信息:', {
            id: result.fromUid,
            code: result.workCode,
            avatar: result.workAvatar
          })
          this.disconnected = false
          this.servicer = {
            id: result.fromUid,
            code: result.workCode,
            avatar: result.workAvatar
          }
          // 聊天记录中添加客服信息
          this.chatControl.chatModel.setInfoTitle({
            id: this.connectId,
            title: CONSTANT.CONNECTED_TIP.replace(/{}/g, result.workCode),
            desc: ' '
          })
          this.chatControl.isLoading = false
          console.log('✅ [SocketControl] 客服分配完成，连接状态更新')
        } else {
          console.log('📨 [SocketControl] 收到客服消息，客服已分配')
        }

        // 获取消息类型
        const types = ['RECEIVE', 'ARTIFICIAL'],
          regImg = /img\[([^\s]+?)\]/g,
          regAudio = /audio\([\s\S]+?\)\[([^\s]+?)\]/g

        const isAudio = regAudio.test(result.message)

        if (regImg.test(result.message)) {
          types.push('IMAGE')
        }
        if (isAudio) {
          types.push('AUDIO')
        }

        console.log('🔍 [SocketControl] 消息类型:', types.join(','))

        // 此消息是否已读
        const { visibilityState } = this.chatControl
        if (visibilityState && result.chatUid && !isAudio) {
          console.log('🔍 [SocketControl] 标记消息已读:', result.chatUid)
          this.read(result.chatUid)
        }

        // 输入中替换为接收的消息
        this.chatControl.addInfoByReceive({
          id: result.chatUid,
          title: result.message,
          type: types.join(','),
          unread: isAudio || !visibilityState
        })

        // 首次连接成功发送默认语
        // this.auoReply.addInfoByFirst()
        // 清除客服未回消息自动回复
        this.auoReply.clearReply()
      })
    })
  }

  /**
   * 客服中断或离开
   */
  signOut() {
    console.log('🔍 [SocketControl] 设置客服中断监听')
    this.socket.on('seat.out', () => {
      console.log('⚠️ [SocketControl] 客服中断或离开')
      const text = CONSTANT.RECONNECT_TIP.replace(/{}/g, this.servicer.code)
      this.socket.close()
      this.chatControl.addInfoBySystem(text)
      this.disconnected = true
      this.chatControl.connected = false
    })
  }

  /**
   * 排队等待
   */
  lineUp() {
    console.log('🔍 [SocketControl] 设置排队等待监听')
    this.socket.on('queue.in', data => {
      console.log('⏳ [SocketControl] 进入排队等待:', data)
      this.chatControl.isLoading = true
      this.chatControl.chatModel.setLoading(this.connectId, data.message)
    })
  }

  /**
   * 暂无客服状态
   */
  empty() {
    console.log('🔍 [SocketControl] 设置暂无客服状态监听')
    this.socket.on('seat.empty', data => {
      console.log('❌ [SocketControl] 暂无客服可用:', data)
      this.chatControl.chatModel.remove(this.connectId)
      if (data.search('96510') > -1) {
        console.log('🔍 [SocketControl] 检测到96510，显示不在时间提示')
        this.chatControl.addInfoNotTime()
      } else {
        console.log('🔍 [SocketControl] 显示暂无客服提示')
        this.chatControl.addInfoBySystem(data)
      }
    })
  }

  /**
   * 信息撤回
   * @param {Object} info
   */
  withdraw(info) {
    return new Promise((resolve, reject) => {
      const params = {
        fromUid: this.chatControl.userInfo.token,
        toUid: this.servicer.id,
        message: info.title,
        chatUid: info.id
      }
      this.socket.emit('withdraw.user.mobile', params, res => {
        if (res.code === 1) {
          resolve(res.data)
        } else {
          reject(res.msg)
        }
      })
    })
  }

  /**
   * 客服撤回
   */
  customerWithdraw() {
    this.socket.on('withdraw.admin.mobile', data => {
      const { chatControl, servicer } = this
      chatControl.chatModel.remove(data.chatUid)
      chatControl.addInfoBySystem(`"客服${servicer.code}"撤回了一条消息`)
    })
  }

  /**
   * 正在输入中
   * @param {number} status 1:输入中 2:离开
   */
  entering(status) {
    const params = {
      fromUid: this.chatControl.userInfo.token,
      toUid: this.servicer.id,
      message: status
    }
    this.socket.emit('enter.from.user', params)
  }

  /**
   * 客服输入中
   */
  customerEntering() {
    this.socket.on('enter.from.admin', data => {
      if (data.message === '1') {
        this.chatControl.addInfoOfInput()
      } else {
        this.chatControl.removeInfoOfInput()
      }
    })
  }

  /**
   * 消息已读
   * @param {string} ids 信息id集合
   */
  read(ids) {
    const { chatControl, servicer } = this
    const params = {
      readIds: ids,
      fromUid: chatControl.userInfo.token,
      toUid: servicer.id
    }
    this.socket.emit('read.from.user', params, res => {
      if (res) {
        chatControl.chatModel.setRead(ids)
      }
    })
  }

  /**
   * 客服消息已读
   */
  customerRead() {
    this.socket.on('read.from.admin', data => {
      if (data) {
        this.chatControl.chatModel.setRead(data.readIds)
      }
    })
  }

  /**
   * 中断连接
   */
  disconnect() {
    this.socket.disconnect()
    this.chatControl.addInfoBySystem(CONSTANT.RECONNECT_TIMEOUER_TIP)
    this.disconnected = true
    this.chatControl.connected = false
    this.chatControl.reconnectd = true
  }
}

export default SocketModel



// WEBPACK FOOTER //
// ./src/controller/modules/socketControl.js